export default __webpack_public_path__ + "static/media/decrease.59ff38a3.svg";